import * as React from 'react';
import c from 'classnames';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import type { TaxonomyProjectType } from '../../../../types/uncinc_profile/taxonomy';

interface ThemeProps {
  entity: ImmutableEntity<TaxonomyProjectType>;
}

const TaxonomyProjectTypeTitle: React.FC<ThemeProps> = ({
  entity,
  ...props
}) => (
  <h2 className={c('TaxonomyProjectTypeTitle')} {...props}>
    {entity.getIn(['name', 0, 'value'])}
  </h2>
);

export default TaxonomyProjectTypeTitle;
